<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-select v-model="model" placeholder="请选择固件型号" clearable>
          <el-option
            v-for="item in firmwareData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select v-model="parentModel" placeholder="请选择整机型号" clearable>
          <el-option
            v-for="item in overUnitData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-col>
      <el-col :span="10">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="2">
        <el-button type="success" @click="handleAdd">新增</el-button>
      </el-col>
    </el-row>

    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column prop="create_time" label="创建时间"> </el-table-column>
      <el-table-column prop="model" label="固件型号"> </el-table-column>
      <el-table-column prop="parentModel" label="整机型号"> </el-table-column>
      <el-table-column prop="feature" label="固件特点"> </el-table-column>
      <el-table-column prop="description" label="固件描述"> </el-table-column>
      <el-table-column prop="default_page" label="默认参数列表">
        <template slot-scope="scope">
          {{scope.row.default_page && scope.row.default_page.map(i => i.name).join(",")}}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="onConfig(scope.row)"
            >配置参数</el-button
          >
          <el-button type="text" size="small" @click="Edit(scope.row)"
            >编辑</el-button
          >
          <el-button @click="Delete(scope.row)" type="text" size="small"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
    <el-dialog
      :title="title"
      center
      :visible.sync="contentVisible"
      :close-on-click-modal="false"
      width="38%"
      @closed="handleClose"
    >
      <el-form
        :model="contentForm"
        ref="contentForm"
        label-width="100px"
        :rules="contentRules"
      >
        <el-form-item label="固件型号" prop="model">
          <el-input placeholder="请输入" v-model="contentForm.model"></el-input>
        </el-form-item>
        <el-form-item label="整机型号" prop="parentModel">
          <el-select v-model="contentForm.parentModel" placeholder="请选择">
            <el-option
              v-for="item in overUnitData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="固件特点" prop="feature">
          <el-input
            placeholder="请输入"
            v-model="contentForm.feature"
          ></el-input>
        </el-form-item>
        <el-form-item label="固件描述" prop="description">
          <el-input
            placeholder="请输入"
            v-model="contentForm.description"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('contentForm')"
            >提交</el-button
          >
          <el-button @click="resetForm('contentForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="配置参数"
      center
      :visible.sync="configVisible"
      width="38%"
      height="50%"
      :close-on-click-modal="false"
      @closed="closeConfig"
    >
      <el-tabs
        tab-position="left"
        style="height: 520px"
        v-model="activeName"
        @tab-click="handleTab"
      >
        <el-tab-pane
          v-for="item in tabData"
          :key="item.id"
          :label="item.title"
          :name="item.id"
        >
          <div class="scrollable-content">
            <el-checkbox-group
              v-model="selectedData[item.id]"
              class="vertical-layout"
            >
              <el-checkbox
                v-for="subItem in item.content"
                :key="subItem.code"
                :label="subItem.code"
                >{{ subItem.name }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-row type="flex" justify="center">
        <el-button type="primary" @click="submitConfig">提交</el-button>
        <el-button @click="onCancelConfig">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  data() {
    return {
      title: "新建",
      activeName: "default_page",
      contentVisible: false,
      configVisible: false,
      parentModel: "", //搜索框
      model: "",
      data: [],
      rowData: {},
      selectedData: {},
      abilityData: [],
      tabData: [
        {
          id: "default_page",
          title: "默认数据页",
          content: [],
        },
        {
          id: "map_page",
          title: "地图数据页",
          content: [],
        },
        {
          id: "his_page",
          title: "历史数据页",
          content: [],
        },
        {
          id: "param_edit_page",
          title: "设备编辑页",
          content: [],
        },
        {
          id: "online_his_page",
          title: "在线列表历史数据页",
          content: [],
        },
        {
          id: "terminal_page",
          title: "终端显示数据页",
          content: [],
        },
        {
          id: "online_latest_data_page",
          title: "在线列表最新数据页",
          content: [],
        },
      ],
      contentForm: {
        model: "",
        parentModel: "",
        feature: "",
        description: "",
      },
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      contentRules: {
        model: [{ required: true, message: "请输入", trigger: "blur" }],
        parentModel: [{ required: true, message: "请选中", trigger: "blur" }],
        feature: [{ required: true, message: "请输入", trigger: "blur" }],
        description: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      overUnitData: [],
      firmwareData: [],
    };
  },
  mounted() {
    const params = {
      pageNum: 1,
      pageSize: 99999,
    };
    this.$http.post("/manage/machine/page", params).then((results) => {
      const filterValue = results["data"]["data"]["records"].map((i) => {
        return {
          value: i.model,
          label: i.model,
        };
      });
      this.overUnitData = filterValue;
    });
    this.$http.post("/manage/core/page", params).then((results) => {
      const filterValue = results["data"]["data"]["records"].map((i) => {
        return {
          value: i.id,
          label: i.model,
        };
      });
      this.firmwareData = filterValue;
    });
    this.$http.post("/manage/ability/list", params).then((res) => {
      const filterValue = res["data"]["data"]["records"].map((i) => {
        return {
          code: i.type,
          name: i.name,
        };
      });
      this.abilityData = filterValue;
      this.tabData.map((i) => {
        i.content = filterValue;
        return i;
      });
    });
    this.tabData.forEach((item) => {
      this.$set(this.selectedData, item.id, []);
    });
  },
  methods: {
    handleTab(tab) {
      this.activeName = tab.name;
    },
    filterValue(value) {
      return value.map((i) => {
        const filterValue = this.abilityData.filter((s) => s.code === i);
        return filterValue && !!filterValue.length
          ? {
              code: filterValue[0].code,
              name: filterValue[0].name,
              display_switch: true,
            }
          : null;
      });
    },
    submitConfig() {
      const default_page = this.filterValue(this.selectedData.default_page);
      const his_page = this.filterValue(this.selectedData.his_page);
      const map_page = this.filterValue(this.selectedData.map_page);
      const online_his_page = this.filterValue(
        this.selectedData.online_his_page
      );
      const online_latest_data_page = this.filterValue(
        this.selectedData.online_latest_data_page
      );
      const param_edit_page = this.filterValue(
        this.selectedData.param_edit_page
      );
      const terminal_page = this.filterValue(this.selectedData.terminal_page);
      const params = {
        ...this.rowData,
        default_page,
        his_page,
        map_page,
        online_his_page,
        online_latest_data_page,
        param_edit_page,
        terminal_page,
      };
      this.$http.post("/manage/rom-model/save", params).then((res) => {
        if (res.data) {
          this.configVisible = false;
          this.$message({
            message: "修改成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    onCancelConfig() {
      this.configVisible = false;
    },
    onConfig(data) {
      this.configVisible = true;
      const params = { model: data.model, machineModel: data.parentModel };
      this.activeName = "default_page";
      this.$http
        .post("/manage/rom-model/getDetailByModel", params)
        .then((results) => {
          if (results.data.code === 0) {
            const value = results.data.data;
            this.rowData = value;
            const default_page =
              (value.default_page && value.default_page.map((i) => i.code)) ||
              [];
            const his_page =
              (value.his_page && value.his_page.map((i) => i.code)) || [];
            const map_page =
              (value.map_page && value.map_page.map((i) => i.code)) || [];
            const online_his_page =
              (value.online_his_page &&
                value.online_his_page.map((i) => i.code)) ||
              [];
            const online_latest_data_page =
              (value.online_latest_data_page &&
                value.online_latest_data_page.map((i) => i.code)) ||
              [];
            const param_edit_page =
              (value.param_edit_page &&
                value.param_edit_page.map((i) => i.code)) ||
              [];
            const terminal_page =
              (value.terminal_page && value.terminal_page.map((i) => i.code)) ||
              [];
            this.selectedData = {
              default_page,
              his_page,
              map_page,
              online_his_page,
              online_latest_data_page,
              param_edit_page,
              terminal_page,
            };
          } else {
            this.rowData = params;
            this.selectedData = {
              default_page: [],
              map_page: [],
              his_page: [],
              online_his_page: [],
              online_latest_data_page: [],
              param_edit_page: [],
              terminal_page: [],
            };
          }
        });
    },
    closeConfig() {
      this.configVisible = false;
    },
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    handleAdd() {
      this.contentVisible = true;
      this.title = "添加";
    },
    handleClose() {
      this.contentVisible = false;
      this.contentForm = {};
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        model: this.model,
        parentModel: this.parentModel,
      };
      this.$http.post("/manage/core/page", params).then((results) => {
        this.data = results["data"]["data"]["records"];
        this.pagin.total = results["data"]["data"]["total"];
      });
    },
    Edit(data) {
      this.contentVisible = true;
      this.title = "编辑";
      this.contentForm = data;
    },
    Delete(data) {
      //单删
      if (confirm("确认要删除吗？")) {
        this.$http.post("/manage/core/delete", { id: data.id }).then((res) => {
          if (res.data.code === 0) {
            this.getList();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.contentForm);
          this.$http.post("/manage/core/save", this.contentForm).then((res) => {
            if (res.data.code === 0) {
              this.getList();
              this.$message({
                message: "保持成功",
                type: "success",
              });
              this.$refs[formName].resetFields();
              this.contentVisible = false;
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
            }
          });
        }
      });
    },
    resetForm(formName) {
      this.contentVisible = false;
      this.$refs[formName].resetFields();
    },
  },
  components: { Pagination },
};
</script>
<style>
.vertical-layout {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 8px;
  padding-left: 16%;
}
.scrollable-content {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 16px;
  height: 520px;
}
</style>
